import React from 'react';
import { ImageViewer } from 'antd-mobile';

import { ImgViewerDownloadIcon } from '@whelk/assets/src/mobile/icons';

import './style.scss';

const MobileImgMask = ({
  open,
  onClose,
  imgMaskUrlList,
  currentImgIndex,
  setCurrentImgIndex,
  onClickDownLoadImg,
}: {
  open: boolean;
  onClose: () => void;
  imgMaskUrlList: string[];
  currentImgIndex: number;
  onClickDownLoadImg: () => void;
  setCurrentImgIndex: (index: number) => void;
}) => {
  return (
    <ImageViewer.Multi
      visible={open}
      onClose={onClose}
      images={imgMaskUrlList}
      defaultIndex={currentImgIndex}
      onIndexChange={(index: number) => setCurrentImgIndex(index)}
      classNames={{ mask: 'mllti-img-viewer-mask', body: 'mllti-img-viewer-body' }}
      renderFooter={() => (
        <div className='flex w-full flex-row items-center justify-center'>
          {/* 占位区域 */}
          <div className='w-[48px]'></div>

          <div className='flex flex-1 flex-row items-center justify-center'>
            {imgMaskUrlList &&
              imgMaskUrlList.length > 1 &&
              imgMaskUrlList.map((_, index) => (
                <div
                  key={index}
                  className={`mr-1.5 h-1.5 w-1.5 rounded-full last-of-type:mr-0 ${
                    index === currentImgIndex ? 'bg-[#C3FAAF]' : 'bg-[rgba(255,255,255,0.20)]'
                  } `}
                />
              ))}
          </div>

          <div
            onClick={onClickDownLoadImg}
            className='mr-3 rounded-xl bg-[rgba(255,255,255,0.20)] p-2'
          >
            <ImgViewerDownloadIcon />
          </div>
        </div>
      )}
    />
  );
};

export default MobileImgMask;
